import Avatar from '@mui/material/Avatar';
import { useTheme } from '@mui/material/styles';


const Icon = props => {
    const theme = useTheme();
    const baseUrl = 'https://s3.us-east-1.amazonaws.com/dash.kippdcdata.org/images/systems'
    return (
        <Avatar
            src={props.system && `${baseUrl}/${props.system}.png`}
            sx={{
                color: theme.palette[props.color || 'primary'].main
            }}
            children={props.icon || ''}
        />
    )
}
export default Icon